import updateCookies from "../../helpers/updateCookies";
import { api } from "../../services/api";
import { Handler } from "../types/store-types";

import {
    IAuthState,
    AuthActionTypes,
    SetLoadingActionType,
    ClearErrorsActionType,
    InitUserRequestActionType,
    SetUserTokenActionType,
    InitUserSuccessActionType,
    InitUserFailureActionType,
    MigrateGuestToUserRequestActionType,
    MigrateGuestToUserSuccessActionType,
    MigrateGuestToUserFailureActionType,
    IUserTypes,
    GetCurrentUserRequestActionType,
    GetCurrentUserSuccessActionType,
    GetCurrentUserFailureActionType,
    UserRoles,
    GetZapierAuthURLRequestActionType,
    GetZapierAuthURLSuccessActionType,
    GetZapierAuthURLFailureActionType,
    IZapierState,
    GetHubspotAuthURLRequestActionType,
    IHubspotState,
    GetHubspotAuthURLSuccessActionType,
    GetHubspotAuthURLFailureActionType,
    GetHubspotDataRequestActionType,
    GetHubspotDataSuccessActionType,
    GetHubspotDataFailureActionType,
    GetHubspotStatusRequestActionType,
    GetHubspotStatusSuccessActionType,
    GetHubspotStatusFailureActionType,
    IUpdateHubspotPropertyFailureData,
    UpdateHubspotPropertyFailureActionType,
    IUpdateHubspotPropertySuccessData,
    UpdateHubspotPropertySuccessActionType,
    UpdateHubspotPropertyRequestActionType,
    GetHubspotTablesRequestActionType,
    GetHubspotTablesSuccessActionType,
    GetHubspotTablesFailureActionType,
    IGetHubspotTablesSuccessData,
    IGetHubspotTablesFailureData,
    InitHubspotRequestActionType,
    InitHubspotSuccessActionType,
    InitHubspotFailureActionType,
    DisconnectIntegrationFailureActionType,
    DisconnectIntegrationSuccessActionType,
    DisconnectIntegrationRequestActionType,
    IDisconnectIntegrationState,
    IHubspotStatusState,
} from "./types";

/* -- Init User Request Handler -- */

const initUserRequest: Handler<IAuthState, InitUserRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const initUserSuccess: Handler<IAuthState, InitUserSuccessActionType> = (
    state,
    { payload: { token, refresh_token, userType } },
) => {
    return {
        ...state,
        isLoading: false,
        userType,
        token,
        refresh_token,
        errors: null,
    };
};

const initUserFailure: Handler<IAuthState, InitUserFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, errors: payload };
};

const getCurrentUserRequest: Handler<IAuthState, GetCurrentUserRequestActionType> = state => {
    return { ...state };
};
const getCurrentUserSuccess: Handler<IAuthState, GetCurrentUserSuccessActionType> = (state, { payload }) => {
    const { first_name, last_name, role, ...rest } = payload;
    const userType = role === UserRoles.GUEST ? IUserTypes.GUEST : IUserTypes.USER;

    return {
        ...state,
        userType,
        user: {
            ...rest,
            role: userType,
            name: first_name + " " + last_name, // I know this is not good , update to more effective code  :)
        },
    };
};
const getCurrentUserFailure: Handler<IAuthState, GetCurrentUserFailureActionType> = state => {
    return { ...state };
};

const migrateUserRequest: Handler<IAuthState, MigrateGuestToUserRequestActionType> = (state, { payload }) => {
    return { ...state };
};
const migrateUserSuccess: Handler<IAuthState, MigrateGuestToUserSuccessActionType> = (
    state,
    { payload: { userId: token, userRefreshToken: refresh_token } },
) => {
    localStorage.clear();
    localStorage.setItem("token", token);
    localStorage.setItem("refresh_token", refresh_token);
    api.defaults.headers.common["x-access-token"] = token;
    return { ...state, token, refresh_token, userType: IUserTypes.USER };
};
const migrateUserFailure: Handler<IAuthState, MigrateGuestToUserFailureActionType> = (state, { payload }) => {
    return { ...state };
};

const setUserToken: Handler<IAuthState, SetUserTokenActionType> = (state, { payload: { token, refresh_token } }) => {
    localStorage.clear();
    localStorage.setItem("token", token);
    localStorage.setItem("refresh_token", token);
    api.defaults.headers.common["x-access-token"] = token;
    updateCookies(token, refresh_token);
    return { ...state, token, refresh_token };
};

const setLoading: Handler<IAuthState, SetLoadingActionType> = (state, { payload: { isLoading } }) => {
    return { ...state, isLoading };
};

const clearErrors: Handler<IAuthState, ClearErrorsActionType> = state => {
    return { ...state, errors: null };
};

const getZapierAuthURLRequest: Handler<IZapierState, GetZapierAuthURLRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getZapierAuthURLSuccess: Handler<IZapierState, GetZapierAuthURLSuccessActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, authUrl: payload.authUrl, formId: payload.formId, errors: null };
};

const getZapierAuthURLFailure: Handler<IZapierState, GetZapierAuthURLFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, errors: payload };
};

const getHubspotAuthURLRequest: Handler<IHubspotState, GetHubspotAuthURLRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getHubspotAuthURLSuccess: Handler<IHubspotState, GetHubspotAuthURLSuccessActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, authUrl: payload.data, errors: null };
};

const getHubspotAuthURLFailure: Handler<IHubspotState, GetHubspotAuthURLFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, errors: payload };
};

const getHubspotDataRequest: Handler<IHubspotState, GetHubspotDataRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getHubspotDataSuccess: Handler<IHubspotState, GetHubspotDataSuccessActionType> = (state, { payload }) => {
    return {
        ...state,

        hubspotData: payload,
    };
};

const getHubspotDataFailure: Handler<IHubspotState, GetHubspotDataFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, errors: payload };
};

const getHubspotStatusRequest: Handler<IHubspotStatusState, GetHubspotStatusRequestActionType> = state => {
    return { ...state };
};

const getHubspotStatusSuccess: Handler<IHubspotStatusState, GetHubspotStatusSuccessActionType> = (
    state,
    { payload },
) => {
    return {
        ...state,
        status: payload.data,
        message: payload.message,
        success: payload.success,
    };
};

const getHubspotStatusFailure: Handler<IHubspotStatusState, GetHubspotStatusFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, errors: payload };
};

const updateHubspotPropertyRequest: Handler<IHubspotState, UpdateHubspotPropertyRequestActionType> = state => {
    return { ...state, isLoading: true };
};
const updateHubspotPropertySuccess: Handler<IHubspotState, UpdateHubspotPropertySuccessActionType> = (
    state,
    action: { payload: IUpdateHubspotPropertySuccessData },
) => {
    return {
        ...state,
        success: true,
        message: action.payload.message,
        hubspotData: action.payload.data
            ? {
                  hubspotData: {
                      table: action.payload.data.tableName,
                      fields: {
                          [action.payload.data.tableName]: action.payload.data.fields.tableName,
                      },
                      _id: action.payload.data._id || "",
                  },
              }
            : null,
        isLoading: false,
        error: null,
    };
};
const updateHubspotPropertyFailure: Handler<IHubspotState, UpdateHubspotPropertyFailureActionType> = (
    state,
    action: { payload: IUpdateHubspotPropertyFailureData },
) => {
    return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
    };
};

const getHubspotTablesRequest: Handler<IHubspotState, GetHubspotTablesRequestActionType> = state => {
    return { ...state, isLoading: true };
};
const getHubspotTablesSuccess: Handler<IHubspotState, GetHubspotTablesSuccessActionType> = (
    state,
    action: { payload: IGetHubspotTablesSuccessData },
) => {
    return {
        ...state,
        success: true,
        message: action.payload.message,
        hubspoTablesData: action.payload.data,
    };
};
const getHubspotTablesFailure: Handler<IHubspotState, GetHubspotTablesFailureActionType> = (
    state,
    action: { payload: IGetHubspotTablesFailureData },
) => {
    return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
    };
};

const initHubspotRequest: Handler<IHubspotState, InitHubspotRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const initHubspotSuccess: Handler<IHubspotState, InitHubspotSuccessActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, authUrl: payload.data, errors: null };
};

const initHubspotFailure: Handler<IHubspotState, InitHubspotFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, errors: payload };
};

const disconnectIntegrationRequest: Handler<
    IDisconnectIntegrationState,
    DisconnectIntegrationRequestActionType
> = state => {
    return { ...state, isLoading: true };
};

const disconnectIntegrationSuccess: Handler<IDisconnectIntegrationState, DisconnectIntegrationSuccessActionType> = (
    state,
    { payload },
) => {
    return {
        ...state,
        success: true,
        message: payload.message,
        data: payload.data,
    };
};

const disconnectIntegrationFailure: Handler<IDisconnectIntegrationState, DisconnectIntegrationFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, error: payload };
};
export const authHandlers = {
    [AuthActionTypes.INIT_USER_REQUEST]: initUserRequest,
    [AuthActionTypes.INIT_USER_SUCCESS]: initUserSuccess,
    [AuthActionTypes.INIT_USER_FAILURE]: initUserFailure,

    [AuthActionTypes.GET_CURRENT_USER_REQUEST]: getCurrentUserRequest,
    [AuthActionTypes.GET_CURRENT_USER_SUCCESS]: getCurrentUserSuccess,
    [AuthActionTypes.GET_CURRENT_USER_FAILURE]: getCurrentUserFailure,

    [AuthActionTypes.MIGRATE_GUEST_TO_USER_REQUEST]: migrateUserRequest,
    [AuthActionTypes.MIGRATE_GUEST_TO_USER_SUCCESS]: migrateUserSuccess,
    [AuthActionTypes.MIGRATE_GUEST_TO_USER_FAILURE]: migrateUserFailure,

    [AuthActionTypes.SET_USER_TOKEN]: setUserToken,
    [AuthActionTypes.SET_LOADING]: setLoading,
    [AuthActionTypes.CLEAR_ERRORS]: clearErrors,
};

export const disconnectIntegrationHandlers = {
    [AuthActionTypes.DISCONNECT_INTEGRATION_REQUEST]: disconnectIntegrationRequest,
    [AuthActionTypes.DISCONNECT_INTEGRATION_SUCCESS]: disconnectIntegrationSuccess,
    [AuthActionTypes.DISCONNECT_INTEGRATION_FAILURE]: disconnectIntegrationFailure,
};
export const zapierHandlers = {
    [AuthActionTypes.GET_ZAPIER_AUTH_URL_REQUEST]: getZapierAuthURLRequest,
    [AuthActionTypes.GET_ZAPIER_AUTH_URL_SUCCESS]: getZapierAuthURLSuccess,
    [AuthActionTypes.GET_ZAPIER_AUTH_URL_FAILURE]: getZapierAuthURLFailure,
};

export const hubspotHandlers = {
    [AuthActionTypes.GET_HUBSPOT_AUTH_URL_REQUEST]: getHubspotAuthURLRequest,
    [AuthActionTypes.GET_HUBSPOT_AUTH_URL_SUCCESS]: getHubspotAuthURLSuccess,
    [AuthActionTypes.GET_HUBSPOT_AUTH_URL_FAILURE]: getHubspotAuthURLFailure,

    [AuthActionTypes.GET_HUBSPOT_DATA_REQUEST]: getHubspotDataRequest,
    [AuthActionTypes.GET_HUBSPOT_DATA_SUCCESS]: getHubspotDataSuccess,
    [AuthActionTypes.GET_HUBSPOT_DATA_FAILURE]: getHubspotDataFailure,

    [AuthActionTypes.GET_HUBSPOT_STATUS_REQUEST]: getHubspotStatusRequest,
    [AuthActionTypes.GET_HUBSPOT_STATUS_SUCCESS]: getHubspotStatusSuccess,
    [AuthActionTypes.GET_HUBSPOT_STATUS_FAILURE]: getHubspotStatusFailure,

    [AuthActionTypes.UPDATE_HUBSPOT_PROPERTY_REQUEST]: updateHubspotPropertyRequest,
    [AuthActionTypes.UPDATE_HUBSPOT_PROPERTY_SUCCESS]: updateHubspotPropertySuccess,
    [AuthActionTypes.UPDATE_HUBSPOT_PROPERTY_FAILURE]: updateHubspotPropertyFailure,

    [AuthActionTypes.GET_HUBSPOT_TABLES_REQUEST]: getHubspotTablesRequest,
    [AuthActionTypes.GET_HUBSPOT_TABLES_SUCCESS]: getHubspotTablesSuccess,
    [AuthActionTypes.GET_HUBSPOT_TABLES_FAILURE]: getHubspotTablesFailure,

    [AuthActionTypes.INIT_HUBSPOT_REQUEST]: initHubspotRequest,
    [AuthActionTypes.INIT_HUBSPOT_SUCCESS]: initHubspotSuccess,
    [AuthActionTypes.INIT_HUBSPOT_FAILURE]: initHubspotFailure,
};
